import { useMemo } from 'react';

import {
  buildGeoAreaNameMap,
  useGetGeoAreaTree
} from '@/features/api/hooks/shared-app/useGetGeoAreaTree';

/**
 * Fetches the geo area tree for the given organization and returns a flat
 * `id -> name` lookup map. When `organizationId` is undefined the query is
 * disabled and an empty map is returned.
 *
 * @param organizationId - The creator organization id, or undefined when not yet known
 * @returns A memoized `Map<string, string>` mapping geo area ids to names
 */
export const useGeoAreaNameMap = (organizationId?: string) => {
  const { data: geoAreaTree } = useGetGeoAreaTree(organizationId);

  return useMemo(() => buildGeoAreaNameMap(geoAreaTree), [geoAreaTree]);
};
